import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { Task } from 'app/models';
import { TaskType } from 'app/models/enums';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const taskUrl = `${environment.apiUrl}/tasks`;
const taskStatusUrl = taskId => `${environment.apiUrl}/tasks/${taskId}`;
const taskTypeUrl = taskType => `${environment.apiUrl}/tasks/type/${taskType}`;
const taskEncodeVildUrl = (id: number) => `${taskUrl}/encodeVild/${id}`;
const vildDecodeVildUrl = `${taskUrl}/decodeVild`;
const fcdImportTaskType = TaskType.FcdImportTask;

@Injectable()
export class TaskService {
  constructor(private readonly httpService: HttpService) {}

  getAllTasks(): Observable<Task[]> {
    return this.httpService.get<Task[]>(taskUrl);
  }

  getTaskUrl(taskId: number) {
    return taskStatusUrl(taskId);
  }

  getTask(taskId: number): Observable<Task> {
    return this.httpService.get<Task>(taskStatusUrl(taskId));
  }

  getTaskByType(taskType: string): Observable<Task> {
    return this.httpService.get<Task>(taskTypeUrl(taskType));
  }

  startFcdImportTaskFromBlob(mapId: number): Observable<any> {
    return this.httpService.post(taskUrl, { type: fcdImportTaskType, mapVersion: mapId });
  }

  startEncodeVildTask(id: number): Observable<any> {
    return this.httpService.post(taskEncodeVildUrl(id), {});
  }

  startDecodeVildTask(): Observable<any> {
    return this.httpService.post(vildDecodeVildUrl, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/services/task.service.ts